export default {
	islogin(state) {
		return state.login
	},
	userInfo(state) {
		return state.userInfo
	},
	editStep(state) {
		return state.editStep
	}
}